import Equipment from "../photos/Equipment.JPG";
import RetainingWall1 from "../photos/RetainingWall1.JPG";
import retainingWall2 from "../photos/retainingWall2.jpg";
import RainDrain1 from "../photos/RainDrain1.JPG";
import RainDrain2 from "../photos/RainDrain2.JPG";
import RainDrain3 from "../photos/RainDrain3.jpg";
import BeforeAfter from "../photos/BeforeAfter.png";

const imageArray = [
  { src: BeforeAfter, legend: "Before and After" },
  { src: RetainingWall1, legend: "Retaining Wall" },
  { src: retainingWall2, legend: "Retaining Wall" },
  { src: RainDrain1, legend: "Rain Drain" },
  { src: RainDrain2, legend: "Rain Drain" },
  { src: RainDrain3, legend: "Rain Drain" },
  { src: Equipment, legend: "Equipment" },
];

export default imageArray;
